import { Column } from "react-table";

export default [
    {
        Header: 'Name',
        accessor: 'name'
    },
    {
        Header: 'Organization',
        accessor: row => row.organization?.name
    },
    {
        Header: 'Priority',
        accessor: 'priority',
        width: "100%"
    }
] as Column<Interfaces.Award.Includes<"organization">>[] 